import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { ROLES } from '../constants/roles.constant';

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    if (authService.getRoleId() === ROLES.DISPOSER){
      router.navigate(['/acknownledgment']);
    } else {
      router.navigate(['/info']);
    }
    return false;
  } else {
    return true;
  }
};
